import { Component, Input } from '@angular/core';
import { AltraParte } from '../../../models/altraparte';

@Component({
    selector: '[altraparte_anagrafica_view]',
  templateUrl: 'altreparti-anagrafica-view.component.html',
})

export class AltrePartiAnagraficaViewComponent {
  @Input()
  altraParte: AltraParte;
}
